module.exports = __webpack_public_path__ + "img/tylenol_sinus_severe_non_drowsy.a3c472d5.png";